export class DuplicateType extends Error {
  public constructor(name: string) {
    super('Duplicate Type: [' + name + '].');
    Object.setPrototypeOf(this, DuplicateType.prototype);
  }
}

export const TypesRegistry = new Map<string, Type>();

export class Type {
  public readonly name: string;

  public constructor(name: string) {
    if (TypesRegistry.has(name)) {
      throw new DuplicateType(name);
    }
    this.name = name;
    TypesRegistry.set(name, this);
  }
}
